import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {}

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 text-center">
          <span className="text-4xl font-bold text-[#001E57]">Something went wrong.</span>
          <p className="text-gray-400">Please refresh the page. If the problem persists, contact support.</p>
          <button
            className="mt-2 rounded bg-[#001E57] px-6 py-2 text-sm font-bold text-white hover:opacity-80"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
